import React from 'react';
import CustomTab from '../CustomTab';
import './CustomTabListView.css';
import { useNavigate } from 'react-router-dom';
import { goTo } from '../../../pages/GeoNonGeo/GeoNonGeoRoute';
import { hrpRuleMasterRoutes } from '@pages/ServiceMaster/ServiceMasterRoutes';

const CustomTabV2 = (props: any) => {
  const { setTabKey, tabState, tabs = [], children, id } = props;
  const navigate=useNavigate()
  const handleSelectTab = (eventKey: string) => {
    setTabKey(eventKey);
    if(goTo[eventKey]){
      navigate(goTo[eventKey],{state:eventKey})
    }else if(hrpRuleMasterRoutes[eventKey]){
      navigate(hrpRuleMasterRoutes[eventKey], { state: eventKey });
    }
  };

  return (
    <CustomTab
      className={'custom-tabs-list-view'}
      defaultActiveKey={tabs[0]}
      justify={true}
      id={id}
      activeKey={tabState}
      handleSelectTab={handleSelectTab}
    >
      {children}
    </CustomTab>
  );
};

export default CustomTabV2;
